import React, { useState, useEffect } from 'react';
import { Shield, X } from 'lucide-react';
import './CookieConsent.css';

const CookieConsent = () => {
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const consent = localStorage.getItem('cookie-consent');
        if (!consent) {
            const timer = setTimeout(() => setIsVisible(true), 2000);
            return () => clearTimeout(timer);
        }
    }, []);

    const handleAccept = () => {
        localStorage.setItem('cookie-consent', 'accepted');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-consent-banner">
            <div className="cookie-content">
                <div className="cookie-icon">
                    <Shield size={20} />
                </div>
                <div className="cookie-text">
                    <p>
                        We use cookies to enhance your experience and analyze our traffic.
                        By clicking "Accept", you consent to our use of cookies.
                        Read our <a href="/privacy">Privacy Policy</a> to learn more.
                    </p>
                </div>
                <div className="cookie-actions">
                    <button onClick={handleAccept} className="btn-accept">Accept</button>
                    <button onClick={() => setIsVisible(false)} className="cookie-close">
                        <X size={18} />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CookieConsent;
